import { z } from 'zod';

const schemaEuropaceProcessOfferEventLinkWithoutToken = z.object({
    category: z.string().nullish(),
    expiresAt: z.coerce.date().nullish(),
    title: z.string().nullish(),
    url: z.string().nullish(),
});

export const schemaEuropaceProcessOfferEventLink = schemaEuropaceProcessOfferEventLinkWithoutToken.extend({
    authorizationEncrypted: z.string().nullish(),
});

export type SchemaEuropaceProcessOfferEventLink = z.infer<typeof schemaEuropaceProcessOfferEventLink>;

// this is the response schema from the europace route /kreditsmart-angebote-backend/antraege/${vorgangsnummer}/ereignisse
// also we need to add optional to every property to make sure that we do not throw an error if we get an unknown value
export const schemaEuropaceProcessOfferEvent = z.object({
    date: z.coerce.date().nullish(),
    documents: z
        .array(
            z.object({
                displayName: z.string().nullish(),
                uri: z.string().nullish(),
            }),
        )
        .nullish(),
    europaceOfferId: z.string().nullish(),
    links: z.array(schemaEuropaceProcessOfferEventLink).nullish(),
    loanProvider: z
        .object({
            id: z.string().nullish(),
            name: z.string().nullish(),
        })
        .nullish(),
    text: z.string().nullish(),
    // could also be an ENUM, but we do not have enough information to define it
    type: z.string().nullish(),
});

export type SchemaEuropaceProcessOfferEvent = z.infer<typeof schemaEuropaceProcessOfferEvent>;

// parse strips the encrypted portal tokens: for change detection and the browser
export const schemaEuropaceProcessOfferEventWithoutToken = schemaEuropaceProcessOfferEvent.extend({
    links: z.array(schemaEuropaceProcessOfferEventLinkWithoutToken).nullish(),
});

export type SchemaEuropaceProcessOfferEventWithoutToken = z.infer<typeof schemaEuropaceProcessOfferEventWithoutToken>;
